import API from './api';

export const verify_user = async (verify_code, deviceToken) => {
    const response = await API.post('/api/v1/auth/verify', {
        code: verify_code,
    }, {
        headers: {
            'Device-Token': deviceToken,
        },
    });
    return response.data;
};

export const top_user_service = async (deviceToken) => {
    const response = await API.get('/api/v2/users/top', {
        headers: {
            'Device-Token': deviceToken,
        },
    });
    return response.data;
};
